export const logger = {
  log: console.log,
  info: console.info,
  warn: console.info,
  logLive: (...args)=>{

  }
}
